export function Footer() {
  return (
    <footer className="relative z-10 mt-16 rounded-t-[40px] bg-ink px-5 py-9 text-center text-[#EADCFF]">
      <h2 className="mb-2 font-display text-2xl font-extrabold text-sun">
        Untuk Ayah &amp; Bunda 🧑‍🍼
      </h2>
      <p className="mx-auto max-w-2xl font-semibold leading-relaxed opacity-90">
        Website ini dibuat sebagai alat bantu edukasi keselamatan untuk anak. Dampingi anak saat
        menjelajah, diskusikan tiap topik, dan sesuaikan dengan kondisi di rumah. Pendampingan orang
        tua tetap menjadi kunci utama keselamatan anak.
      </p>
      <p className="mt-5 font-extrabold">
        Dibuat dengan{' '}
        <span className="inline-block animate-[wiggle_1.2s_ease-in-out_infinite] text-coral">
          ❤️
        </span>{' '}
        bersama Robi si Robot
      </p>
    </footer>
  );
}
